import * as prismic from "@prismicio/client";

const repositoryName = process.env.PRISMIC_REPOSITORY_NAME ?? "proxidize";

export function createClient(config?: prismic.ClientConfig) {
  const client = prismic.createClient(repositoryName, {
    fetchOptions:
      process.env.NODE_ENV === "production"
        ? { next: { tags: ["prismic"] }, cache: "force-cache" }
        : { next: { revalidate: 5 } },
    ...config,
  });

  return client;
}
